define('bundles/email_subscriptions/edit',['require','bundles/common-ui','sections/email_subscriptions/Podio.UI.EmailSubscriptions.Edit'],function(require) {

  require('bundles/common-ui');

  require('sections/email_subscriptions/Podio.UI.EmailSubscriptions.Edit');

});

